import { AxiosResponse } from 'axios';
import { HOTEL_AI_URL } from '../../../../config';
import { ApiResponse } from '../../../../interfaces/models/models/paginated-response.model';
import xeroAxios from '../../../../utils/axios/xero.axios';


const tryToFetchClients = (
    pageNumber: number,
    pageSize: number,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${HOTEL_AI_URL}/hotel-clients/all?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${HOTEL_AI_URL}/hotel-clients/all?page=${pageNumber}&size=${pageSize}`;
    return xeroAxios.put<any>(url, {'accessToken': localStorage?.getItem('xeroAccessToken')});
};

const tryToAddClient = (data: any): Promise<AxiosResponse> => {
    return xeroAxios.post(`${HOTEL_AI_URL}/hotel-clients`, data);
};

const tryToEditClient = (id: string, data: any): Promise<AxiosResponse> => {
    return xeroAxios.put(`${HOTEL_AI_URL}/hotel-clients/${id}`, data);
};

const tryToFetchSingleClient = (id: string): Promise<AxiosResponse<ApiResponse<any>>> => {
    return xeroAxios.get<ApiResponse<any>>(`${HOTEL_AI_URL}/hotel-clients/${id}`);
};

const tryToDeleteClient = (id: string): Promise<AxiosResponse> => {
    return xeroAxios.delete(`${HOTEL_AI_URL}/hotel-clients/${id}/hotel`);
};

export const ClientsService = {
    tryToFetchClients,
    tryToAddClient,
    tryToEditClient,
    tryToDeleteClient,
    tryToFetchSingleClient
};